import { PieceSlider, PieceDescription, PieceUnorderedList, PieceSyntaxHighlighter } from '@store/index';
const PUBLIC_URL = process.env.REACT_APP_URL;

const stockAnalysis = {
    name: 'Stock analysis',
    slug: 'stock-analysis',
    description: 'Discovering trading signals using simple stock analysis algorithms',
    cover: `${PUBLIC_URL}/blog/stocks/stocks.png`,
    clipPath: '50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%',
    tech: ['Python', 'pandas', 'numpy'],
    pieces: [
        {
            type: 'slider',
            images: [
                {
                    url: `${PUBLIC_URL}/blog/stocks/stocks.png`
                }
            ]
        } as PieceSlider,
        {
            type: 'description',
            title: 'Use case',
            description: `Let\'s say you have to find out the right timing signals for buying/selling on the stock marker. 
            As an example we will take the real stock prices for three companies: Amazon, Facebook and Tesla. We will take the data for 2018 year as an example.`,
        } as PieceDescription,
        {
            type: 'syntax highlighter',
            language: 'python',
            code: 
`import pandas as pd
import datetime
import pandas_datareader.data as web
import matplotlib.pyplot as plt
import numpy as np

start = datetime.datetime(2018,1,1)
end = datetime.datetime(2019,1,1)

data = web.DataReader(["TSLA", "AMZN", "FB"], "yahoo", start, end)

tesla = data["Adj Close"]["TSLA"]
amazon = data["Adj Close"]["AMZN"]
facebook = data["Adj Close"]["FB"]`
        } as PieceSyntaxHighlighter,
        {
            type: 'description',
            description: `Here we've got data for 3 companies we mentioned before. In order to better visualize the data we have, let's draw the data for one of the company.`,
        } as PieceDescription,
        {
            type: 'syntax highlighter',
            language: 'python',
            code: 
`amazon.plot(grid = True, figsize=(15, 9))`
        } as PieceSyntaxHighlighter,
        {
            type: 'slider',
            images: [
                {
                    url: `${PUBLIC_URL}/blog/stocks/amazon.png`
                }
            ]
        } as PieceSlider,
        {
            type: 'description',
            description: `Let's put the data for all of the companies altogether:`,
        } as PieceDescription,
        {
            type: 'syntax highlighter',
            language: 'python',
            code: 
`stocks = pd.DataFrame(
    {
        "Tesla": tesla,
        "Amazon": amazon,
        "Facebook": facebook
    }
)
stocks.plot(grid = True, figsize=(15, 9))`
        } as PieceSyntaxHighlighter,
        {
            type: 'slider',
            images: [
                {
                    url: `${PUBLIC_URL}/blog/stocks/three.png`
                }
            ]
        } as PieceSlider,
        {
            type: 'description',
            description: `As you can see stock price for amazon is much diverse then two others. It's hard to define the trading signals in such much diversity. We can make chart to be proportional by adding new Y axis:`,
        } as PieceDescription,
        {
            type: 'syntax highlighter',
            language: 'python',
            code: 
`stocks.plot(grid = True, figsize=(15, 9), secondary_y = ["Tesla", "Facebook"])`
        } as PieceSyntaxHighlighter,
        {
            type: 'slider',
            images: [
                {
                    url: `${PUBLIC_URL}/blog/stocks/three-new-y.png`
                }
            ]
        } as PieceSlider,
        {
            type: 'description',
            description: `As you can see Amazon price is on the left-side Y axis and for the rest companies we have right-side Y axis. 
            Let's try to understand which company performs better using absolute numbers:`,
        } as PieceDescription,
        {
            type: 'syntax highlighter',
            language: 'python',
            code: 
`stock_correlate = stocks.apply(lambda x: x / x[0])
stock_correlate.plot(grid = True, figsize=(15, 9))`
        } as PieceSyntaxHighlighter,
        {
            type: 'slider',
            images: [
                {
                    url: `${PUBLIC_URL}/blog/stocks/three-correlate.png`
                }
            ]
        } as PieceSlider,
        {
            type: 'description',
            description: `As you can see Amazon performed better than others, especially in the middle of the year. Tesla ended up with same results as in the beginning of the year. 
            Facebook fall down a bit. Let's try to build trading signals chart for Amazon. <br/>
            You can find more about signals here: 
            <a href="https://en.wikipedia.org/wiki/Forex_signal">https://en.wikipedia.org/wiki/Forex_signal</a>.<br/><br/>
            In our simple example we would like to have an average (in day's terms) chart using pricing history we have. Let's build three averages for 20, 50 and 100 days. 
            20 is standing for short trading strategy, 50 for medium and 100 for long trading strategy.`,
        } as PieceDescription,
        {
            type: 'syntax highlighter',
            language: 'python',
            code: 
`amazon_20d = np.round(amazon.rolling(window = 20, center = False).mean(), 2)
amazon_50d = np.round(amazon.rolling(window = 50, center = False).mean(), 2)
amazon_100d = np.round(amazon.rolling(window = 100, center = False).mean(), 2)

stocks_mean = pd.DataFrame({
    "Amazon 20d": amazon_20d,
    "Amazon 50d": amazon_50d,
    "Amazon 100d": amazon_100d
})

stocks_mean.plot(grid = True, figsize=(15, 9))`
        } as PieceSyntaxHighlighter,
        {
            type: 'slider',
            images: [
                {
                    url: `${PUBLIC_URL}/blog/stocks/amazon-mean.png`
                }
            ]
        } as PieceSlider,
        {
            type: 'description',
            description: `As you can see in the cart above - the trading signals stays in the place of lines intersection. 
            Strength of the signals can be measured by count of intersections in the same area. In a long strategy I would assume that in the beginning of May there was a signal to buy. 
            And there was as signal to sell in Oct.<br/><br/>Wish you a lucky trading and thank you for reading to the end :)`,
        } as PieceDescription,
        {
            type: 'unordered list',
            title: 'Technologies',
            items: ['Python', 'pandas', 'numpy'],
        } as PieceUnorderedList
    ],
}

export default stockAnalysis;


// WEBPACK FOOTER //
// ./src/store/blog/stock-analysis.tsx